import {
    ArrowPathIcon,
    Cog6ToothIcon,
    UserIcon,
} from '@heroicons/react/24/outline'
import React from 'react'
import { Link } from 'react-router-dom'

export const SupportFeatures: React.FC = () => {
    return (
        <>
            <h1 className="font-bold text-white text-2xl">
                Внедрение и сопровождение системы NOXSYS
            </h1>
            <div className="flex flex-col md:flex-row gap-4">
                <div className="card_item card_item_dark flex flex-col items-center gap-2">
                    <div className="p-2 bg-[#181818] rounded-lg">
                        <ArrowPathIcon width={40} height={40} color="#1051F5" />
                    </div>
                    <h2 className="!m-0">Обновление системы</h2>
                    <p className="text-center grow pb-2">
                        NOXSYS постоянно развивается и обновляется с учетом
                        изменений в законодательстве и потребностей
                        пользователей
                    </p>
                    <div>
                        <Link
                            to=""
                            className="px-4 py-2 text-sm text-black bg-white rounded-full"
                        >
                            Оставить заявку
                        </Link>
                    </div>
                </div>
                <div className="card_item card_item_dark flex flex-col items-center gap-2">
                    <div className="p-2 bg-[#181818] rounded-lg">
                        <UserIcon width={40} height={40} color="#1051F5" />
                    </div>
                    <h2 className="!m-0">Сопровождение</h2>
                    <p className="text-center grow pb-2">
                        Предоставляем сопровождение и обучение на каждом этапе
                        внедрения системы с персональным менеджером
                    </p>
                    <div>
                        <Link
                            to=""
                            className="px-4 py-2 text-sm text-black bg-white rounded-full"
                        >
                            Оставить заявку
                        </Link>
                    </div>
                </div>
                <div className="card_item card_item_dark flex flex-col items-center gap-2">
                    <div className="p-2 bg-[#181818] rounded-lg">
                        <Cog6ToothIcon width={40} height={40} color="#1051F5" />
                    </div>
                    <h2 className="!m-0">Техническая поддержка</h2>
                    <p className="text-center grow pb-2">
                        Надежная техническая поддержка 24/7/365 — всегда на
                        связи, чтобы помочь, проконсультировать и оперативно
                        решить любые вопросы
                    </p>
                    <div>
                        <Link
                            to=""
                            className="px-4 py-2 text-sm text-black bg-white rounded-full"
                        >
                            Оставить заявку
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
